import { memo } from 'react';
import { WithdrawContactFormTemplate } from 'components/templates/WithdrawContactFormTemplate';

type Props = {};

export const WithdrawContactFormPage = memo((_props: Props) => {
	return <WithdrawContactFormTemplate />;
});
